import React from "react";
import bgHomeS5 from "../../assets/landingPage/bg-home-s5.png";
import digitalLibraryImg from "../../assets/landingPage/digital-liberary.png";

export default function DigitalLibrarySectionNew() {
  return (
    <section
      id="digital-library"
      className="w-full py-20 px-4 md:px-8 lg:px-16  bg-cover bg-center relative"
      style={{ backgroundImage: `url(${bgHomeS5})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/60 pointer-events-none"></div>

      <div className="relative z-10 max-w-6xl mx-auto flex flex-col md:flex-row-reverse items-center justify-between gap-12">
        {/* Right Side: Text Info */}
        <div className="flex-1 text-center md:text-left">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-oswald text-secondary tracking-wide uppercase mb-3">
            BOSS AMONGST BOSSES
          </h2>
          <h3 className="text-xl md:text-2xl font-semibold font-oswald text-white tracking-widest uppercase mb-6">
            THE POWER BEHIND THE PLATFORM
          </h3>
          <p className="text-gray-300 font-outfit text-base md:text-lg leading-relaxed max-w-xl mx-auto md:mx-0">
            Boss Amongst Bosses is the driving force behind the platform's digital repository, powering our E-Books, Audio Books, and digital publishing ecosystems. The platform provides tools and resources to empower creators to operate as CEOs of their own digital publishing.
          </p>
        </div>

        {/* Left Side: Crown & Book Logo Emblem */}
        <div className="w-full md:w-1/2 max-w-md flex justify-center">
          <div className="relative group p-1.5 rounded-2xl overflow-hidden hover:scale-105 transition-transform duration-500 shadow-2xl">
            <img
              src={digitalLibraryImg}
              alt="Boss Amongst Bosses Digital Library Emblem"
              className="object-cover rounded-xl h-[280px] w-[280px] md:h-[430px] md:w-[450px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
